import React from 'react';
import { Link } from 'react-router-dom';

const TopicChip = ({ topic }) => {
  return (
    <Link to={`/health/food/${topic.slug}`} className="health-chip">
      {topic.title}
    </Link>
  );
};

export default TopicChip;
